module.exports = __webpack_public_path__ + "static/media/icon-point.13e03298.svg";